import { useSearchBox } from 'react-instantsearch';

export const VirtualSearch: React.FC = () => {
    useSearchBox();

    return null;
};
